import { FC } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import { useAppSelector, useTranslate } from 'hooks';

import { TaxStatements } from './TaxStatements';
import { RejectedMessage } from 'componets/ui';
import { Transactions } from './Transactions';
import { AccountSummary } from './AccountSummary';

import { RequestStatus } from 'utils/constants';

import s from './index.module.scss';
import './index.scss';

const TAB_TO_PATH: Record<string, string> = {
	accountSummary: 'account-summary',
	transactions: 'transaction',
	taxStatements: 'tax-statements',
};

const PATH_TO_TAB: Record<string, string> = {
	'account-summary': 'accountSummary',
	transaction: 'transactions',
	'tax-statements': 'taxStatements',
};

export const Statement: FC = () => {
	const status = useAppSelector((state) => state.statement.status);
	const location = useLocation();
	const navigate = useNavigate();

	const { accountSummaryText, transactionsText, taxStatementsText } = useTranslate([
		'accountSummaryText',
		'transactionsText',
		'taxStatementsText',
	]);

	const currentPath = location.pathname.split('/').pop() || '';
	const type = PATH_TO_TAB[currentPath] || 'accountSummary';

	return (
		<>
			{status === RequestStatus.REJECTED ? (
				<RejectedMessage />
			) : (
				<div className={s.statement}>
					<Tabs
						className="accountTabs"
						type="card"
						defaultActiveKey={type}
						activeKey={type}
						onChange={(v: string) => navigate(`/account/statement/${TAB_TO_PATH[v]}`)}
					>
						<Tabs.TabPane tab={accountSummaryText} key="accountSummary">
							<AccountSummary />
						</Tabs.TabPane>
						<Tabs.TabPane tab={transactionsText} key="transactions">
							<Transactions type={type} />
						</Tabs.TabPane>
						<Tabs.TabPane tab={taxStatementsText} key="taxStatements">
							<TaxStatements isActive={type === 'taxStatements'} />
						</Tabs.TabPane>
					</Tabs>
				</div>
			)}
		</>
	);
};
